<template>
<div class="chapter">
<div class="inner_page">
<p class="chap-title">Acknowledgements</p>
<p class="para">There are many voices and visions that go into putting together a magazine like Vegetarian Times and a book like this one.</p>
<p class="para">It all starts with the recipe developers who create fresh, healthy recipes month after month. Robin Asbell, Ann Gentry, Myra Kornfeld, Donna Meadows, Rochelle Palermo, Nicole Palitti, Victoria Abbott Riccardi, Joyce Sangirardi, Melynda Saldenais, and Elliott Prag keep things tasty for us and came up with the recipes you'll find on the following pages.</p>
<p class="para">Fiona Kennedy and Maggie Patinelli, our recipe testers and frequent recipe contributors, have logged hundreds of hours in the kitchen to make sure each and every recipe works as it is supposed to, occasionally adding a little of this or that to make each dish the best it can possibly be.</p>
<p class="para">The beautiful images that accompany the recipes are taken by supertalented photographers who bring the VT vision to life each month. Thank you Beatriz Da Costa, Andrea Gómez, Jacqueline Hopkins, Richard Jung, John Kelly, Amy Neunsinger, Lisa Romerein, and Dasha Wright for making the dishes look so tempting and delicious.</p>
<p class="para">At Wiley, Anne Ficklen, Cecily McAndrews, Amy Zarkos, and Kevin Watt not only guided this book through all the editorial hoops on the path to publication, but also they were instrumental in creating a cookbook that has the tone and feel of the magazine.</p>
<p class="para">Without Healthy Living Group General Manager Pat Fox or VT's literary agent, Mary Ann Naples, this book never would have reached the Wiley people—or anyone else! They tirelessly championed the concept long before the first word was on a page.</p>
<p class="para">Finally special thanks go out to VT magazine staffers Gabrielle Harradine, Scott Hyers, Don Rice, Jolia Sidona Allen, Amy Spitalnick, and Anna Roberts. In addition to their invaluable input, their collaborative efforts on everything from tasting recipes (really fun) to typing up lists and fact checking pages (really boring) made this book possible.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780470547885f01.vue?736d1670